import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Switch,
} from "react-router-dom";
import { LanguageProvider } from "./components/LanguageContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { CartProvider } from "./contexts/CartContext"; // Import CartProvider
import Navbar from "./components/Navbar/Navbar";
import Subnavbar from "./components/Subnanbar/Subnavbar";
import Breadcrums from "./components/Breadcrums/Breadcrums";
import Home from "../src/pages/Home/Home";
import "./index.css";
import SwissBarDisplay from "./components/SwizzbarDisplay/SwizzbarDisplay";
import ProductDisplay from "./components/ProductDisplay/ProductDisplay";
import CartItems from "./components/CartItems/CartItems"; // Import CartItems
import Footer from "./components/Footer/Footer";
import { BreadcrumbProvider } from "./contexts/Breadcrums"; // Import BreadcrumbProvider
import CheckoutPage from "./components/Checkout/CheckoutPage";
import OrderPage from "./components/Order/OrderPage";

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <CartProvider>
          {" "}
          {/* Wrap with CartProvider */}
          <Router>
            <div className="App flex flex-col min-h-screen">
              <Navbar />
              <Subnavbar />
              <Breadcrums />
              {/* <main
              className={`flex-grow ${
                isDarkMode ? "bg-black text-white" : "bg-white text-black"
              }`}
              > */}
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/swiss-bar" element={<SwissBarDisplay />} />
                <Route path="/product/:id" element={<ProductDisplay />} />
                <Route path="/cart" element={<CartItems />} />{" "}
                {/* Add CartItems route */}
                {/* Add other routes as needed */}
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/order" element={<OrderPage />} />
              </Routes>
              {/* </main> */}
              <Footer />
            </div>
          </Router>
        </CartProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
